import React from 'react';
import * as R from 'ramda';

const CategoryBox = ({info: {bgColor, quantity, name}}) => (
  <li>
    <div>
      <span className='bigProdSquarBullet' style={{backgroundColor: bgColor}} />
      <h4>{quantity}</h4>
      {name}
    </div>
  </li>
);

const CategoryList = ({categories}) =>
  R.map(category => <CategoryBox info={category} key={category.id} />)(
    categories
  );

export default CategoryList;
